import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { FormCreate } from './TeamCreate';
import { Create, Form } from 'react-admin';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { dataProvider } from '../../providers/dataProvider';

export const TeamQuickCreate = ({ open, handleClose, handleSubmit }) => {
  const save = async data => {
    const { data: team } = await dataProvider.create('teams', { data });
    if (team?.id) {
      handleSubmit(team);
    }
  };
  if (!open) return null;
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Crear Equipo
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent sx={{ paddingTop: 0 }}>
        <Create resource="teams" redirect={false} actions={null}>
          <Form onSubmit={values => save(values)}>
            <FormCreate />
          </Form>
        </Create>
      </DialogContent>
    </Dialog>
  );
};
